export default __webpack_public_path__ + "static/Google Meet Guide - For Students-b770edb486da4e4c426e5cb19e3b71cd.pdf";